function _(r, n, t, i) {
  const e = new URL(r, i || __routing_host);
  return a(e.searchParams, n), t && (e.hash = t), e.toString();
}
function a(r, n) {
  Object.keys(n).forEach((t) => {
    u(r, t, n[t]);
  });
}
function u(r, n, t, i) {
  return i && (n = i + "[" + n + "]"), Array.isArray(t) ? (t.forEach((e, o) => {
    u(r, o.toString(), e, n);
  }), r) : typeof t == "object" ? (Object.keys(t).forEach((e) => {
    u(r, e, t[e], n);
  }), r) : (typeof t == "boolean" && (t = Number(t)), r.append(n, t), r);
}
function p(r, n = {}, t) {
  return l() && (r = d(r)), s(r, n, t);
}
function d(r) {
  return r.startsWith(__i18n_fallback) ? r.replace(`${__i18n_fallback}.`, "") : __i18n_available.findIndex((n) => r.startsWith(n)) >= 0 ? r : __i18n_current !== __i18n_fallback ? `${__i18n_current}.${r}` : r;
}
function l() {
  return typeof __i18n_current < "u" && typeof __i18n_fallback < "u" && typeof __i18n_available < "u";
}
function s(r, n, t) {
  const i = __routing_routes[r];
  if (!i)
    throw new Error(`Undefined route: ${r}`);
  const e = b(i, n), o = Object.keys(n).reduce((c, f) => (i.params.includes(f) || (c[f] = n[f]), c), {});
  return _(e, o, t, i.domain);
}
function b(r, n) {
  return r.params.reduce((t, i) => {
    const e = n[i];
    if (!e)
      throw new Error(`Parameter ${i} is required for uri ${r.uri}.`);
    return t.replace(new RegExp(`{${i}??}`), e);
  }, r.uri);
}
export {
  p as route,
  _ as url
};
